// external libs
import { Box, Collapse, makeStyles, Paper } from '@material-ui/core'
import { useEffect, useState } from 'react'

// components
import SubmittedTimeline from './SubmittedTimeline'

// hooks
import useProject from '../../../../services/web/useProject'

// types
import type { GetProjectResultType as Project } from '../../../../services/web/types/responseWebServiceTypes'
import type { SubmittedTimeline as SubmittedTimelineType } from '../../../../services/web/useProject'
import ExportDocumentButton from './ExportDocumentButton'

export interface ProjectTimelineProps {
    project: Project
}

const ProjectTimeline = (props: ProjectTimelineProps) => {
    const { project } = props
    const classes = useStyles()
    const projectServices = useProject()

    const [currentTimeline, setCurrentTimeline] = useState<SubmittedTimelineType | null>(null)
    const [extraTimeline, setExtraTimeline] = useState<SubmittedTimelineType[] | null>(null)
    const [isExpand, setIsExpand] = useState<boolean>(false)

    useEffect(() => {
        const fetchTimeline = async () => {
            try {
                const { result } = await projectServices.getTimeline(project.projectID)
                if (!result) {
                    throw new Error('no result response from api call')
                }

                const [current, ...rest] = result

                setCurrentTimeline(current)
                setExtraTimeline(rest)
            } catch (error) {
                console.error('has an error while fetching project timeline')
            }
        }

        fetchTimeline()
    }, [project.stepID, project.projectID])

    if (!currentTimeline) {
        return null
    }

    return (
        <Paper variant="outlined" className={classes.paper}>
            <Box className={classes.exportButtonWrapper}>
                <ExportDocumentButton
                    projectNo={project.projectNumber}
                    extraTimeline={extraTimeline ?? []}
                    currentTimeline={[currentTimeline]}
                />
            </Box>
            <SubmittedTimeline submittedTimeline={currentTimeline} />

            {extraTimeline && extraTimeline.length > 0 ? (
                <>
                    <Collapse in={isExpand} timeout="auto" unmountOnExit>
                        <Box width="100%" display="flex" flexDirection="column" style={{ gap: 32, marginTop: 32 }}>
                            {extraTimeline.map((e) => (
                                <SubmittedTimeline key={e.submittedID} submittedTimeline={e} />
                            ))}
                        </Box>
                    </Collapse>
                    <button className={classes.seemoreButton} onClick={() => setIsExpand((prev) => !prev)}>
                        {isExpand ? 'ย่อสถานะทั้งหมด' : 'ดูสถานะทั้งหมด'}
                    </button>
                </>
            ) : null}
        </Paper>
    )
}

const useStyles = makeStyles(() => ({
    paper: { padding: '20px', width: '100%', margin: '0px 0px 20px 5px' },
    seemoreButton: {
        marginTop: 16,
        fontSize: 14,
        color: '#2563EB',
        border: 'none',
        backgroundColor: 'transparent',
        padding: 0,
        cursor: 'pointer',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    exportButtonWrapper: {
        display: 'flex',
        justifyContent: 'end',
    },
}))

export default ProjectTimeline
